function epoch(iso) {
    return iso ? new Date(iso).getTime() : 0;
}
/**
 * Group flat mail list items into threads by thread_id. Messages without a
 * thread_id become singleton threads. Within a thread, messages are ordered
 * oldest-first; threads are ordered by their most recent message, newest-first.
 */
export function groupByThread(messages) {
    const groups = new Map();
    for (const m of messages) {
        const key = m.thread_id ?? `single:${m.id}`;
        const arr = groups.get(key);
        if (arr)
            arr.push(m);
        else
            groups.set(key, [m]);
    }
    const threads = [];
    for (const [threadId, msgs] of groups) {
        const sorted = [...msgs].sort((a, b) => epoch(a.internal_date) - epoch(b.internal_date));
        const latest = sorted[sorted.length - 1];
        threads.push({
            threadId,
            subject: sorted[0].subject,
            messages: sorted,
            latestDate: latest.internal_date,
            count: sorted.length,
        });
    }
    threads.sort((a, b) => epoch(b.latestDate) - epoch(a.latestDate));
    return threads;
}
